import React from "react";
import { Chip } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ReplayIcon from "@mui/icons-material/Replay";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import TuneIcon from "@mui/icons-material/Tune";

export const TOKEN_TYPE_LABELS = {
  Bill:        { tr: "Fatura",            bg: "#059669", fg: "#ffffff", icon: ReceiptLongIcon },
  FreeUpload:  { tr: "Ücretsiz Yükleme",  bg: "#0ea5e9", fg: "#ffffff", icon: CardGiftcardIcon },
  GetReturn:   { tr: "İade",              bg: "#e11d48", fg: "#ffffff", icon: CurrencyExchangeIcon },
  Rollback:    { tr: "Otomatik Geri",     bg: "#7c3aed", fg: "#ffffff", icon: ReplayIcon },
  Consumption: { tr: "Tüketim",           bg: "#ea580c", fg: "#ffffff", icon: LocalAtmIcon },
  Adjustment:  { tr: "Düzeltme",          bg: "#475569", fg: "#ffffff", icon: TuneIcon },
};

export default function TokenTypeChip({ type, size = "small", sx = {} }) {
  const config = TOKEN_TYPE_LABELS[type];
  if (!config) {
    return (
      <Chip
        label={type || "—"}
        size={size}
        sx={{ bgcolor: "#cbd5e1", color: "#0f172a", fontWeight: 600, ...sx }}
      />
    );
  }
  const Icon = config.icon;
  return (
    <Chip
      icon={<Icon sx={{ color: `${config.fg} !important`, fontSize: 16 }} />}
      label={config.tr}
      size={size}
      sx={{
        bgcolor: config.bg,
        color: config.fg,
        fontWeight: 600,
        "& .MuiChip-icon": { marginLeft: "6px" },
        ...sx,
      }}
    />
  );
}
